import { render, staticRenderFns } from "./ImportVersionFile.vue?vue&type=template&id=020639e5&scoped=true"
import script from "./ImportVersionFile.vue?vue&type=script&lang=js"
export * from "./ImportVersionFile.vue?vue&type=script&lang=js"
import style0 from "./ImportVersionFile.vue?vue&type=style&index=0&id=020639e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020639e5",
  null
  
)

export default component.exports